export const getPractices = () => {
  const settings = JSON.parse(localStorage.getItem("appSettings"));
  return settings?.practices || [];
};
